import { select } from 'd3-selection';
var TRUNCATE_DOTS_SIZE = 3;
var fitText = function (textElement, label, maxDimension) {
    var isTruncated = false;
    if (label.length === 0) {
        return { isTruncated: isTruncated };
    }
    var element = select(textElement);
    element.text(label);
    var textLength = element.node().getComputedTextLength();
    if (maxDimension >= textLength) {
        return { isTruncated: isTruncated };
    }
    isTruncated = true;
    var averageCharacterDimension = Math.floor(textLength / label.length);
    var charactersFit = Math.floor(maxDimension / averageCharacterDimension);
    var value = label.slice(0, charactersFit - TRUNCATE_DOTS_SIZE) + "...";
    element.text(value);
    return {
        isTruncated: isTruncated,
    };
};
export default fitText;
